import { Address, Emulator, LucidEvolution, PrivateKey } from '@lucid-evolution/lucid';
import 'reflect-metadata';
import { deserealizeEmulator } from '../Commons/conversions';
import { asEntity } from '../Commons/Decorators/Decorator.asEntity';
import { Convertible } from '../Commons/Decorators/Decorator.Convertible';
import { BaseEntity } from './Base/Base.Entity';

@asEntity()
export class EmulatorEntity extends BaseEntity {
    protected static _className: string = 'Emulator';
    protected static _apiRoute: string = 'emulators';

    // #region fields

    @Convertible({ isUnique: true })
    name!: string;

    @Convertible()
    current!: boolean;

    @Convertible({
        fromPlainObject: deserealizeEmulator,
        // toPlainObject: serializeEmulator
    })
    emulator!: Emulator;

    @Convertible()
    zeroTime!: number;

    @Convertible({ type: String })
    privateKeys!: PrivateKey[];

    @Convertible({ isCreatedAt: true })
    createdAt!: Date;

    @Convertible({ isUpdatedAt: true })
    updatedAt!: Date;

    // #endregion fields

    // #region class methods

    public static async getTxCountInEmulator(lucid: LucidEvolution, emulatorDB: EmulatorEntity, address: Address) {
        const count = (emulatorDB.emulator as any).slot;
        return count;
    }

    // #endregion class methods
}
